import {EndpointCaller} from '../../src/lib/Service/Impl/EndpointCaller';
import {EndpointConfig} from '../../src/lib/Service/Impl/EndpointConfig';
import {HttpSpy, MockedResponse} from './HttpSpy';
import {HttpRequest} from '@angular/common/http';
export class EndpointCallerShunt extends EndpointCaller {


    mockResponse: MockedResponse | any = {};
/**
 * @param {?=} config
 */
constructor(config?: EndpointConfig) {
        super(<any>new HttpSpy(), config);
        this.config.baseUri = 'http://www.local.dev/';
    }
/**
 * @param {?} path
 * @param {?} method
 * @param {?} requestData
 * @return {?}
 */
protected createRequestObject(path: string, method: string, requestData: any): HttpRequest<any> {
        return Object.assign(
            super.createRequestObject(path, method, requestData),
            {mockResponse: this.mockResponse}
        );
    }
/**
 * @param {?} response
 * @return {?}
 */
tryGettingObjectFromResponse(response): any {
        return this.getObjectFromResponse(response);
    }
}

function EndpointCallerShunt_tsickle_Closure_declarations() {
/** @type {?} */
EndpointCallerShunt.prototype.mockResponse;
}

